import type { ICellRendererParams } from "ag-grid-community";
import { ChevronRight } from "@mui/icons-material";
import {
  bandSummary,
  isStatusBandRow,
  type StatusBandContext,
  type StatusBandRow as Band,
} from "../pipelineMeeting";

/** The band's content; also used by the sticky header above the grid. */
export function StatusBandContent({
  band,
  onToggle,
}: {
  band: Band;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className="pipeline-status-band"
      aria-expanded={!band.collapsed}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      <ChevronRight
        className="pipeline-status-band__chevron"
        style={{ transform: band.collapsed ? "none" : "rotate(90deg)" }}
      />
      <span className="pipeline-status-band__name">{band.statusName}</span>
      <span className="pipeline-status-band__summary">{bandSummary(band)}</span>
    </button>
  );
}

/** Full-width heading for each status group in meeting mode. */
export function StatusBandRow(params: ICellRendererParams) {
  const band = params.data;
  if (!isStatusBandRow(band)) return null;
  const context = params.context as StatusBandContext | undefined;
  return (
    <StatusBandContent
      band={band}
      onToggle={() => context?.toggleBand(band.id)}
    />
  );
}
